export default __webpack_public_path__ + "static/media/JenniferGoetz.a4b8310c.jpeg";